export const heroTitle1 = "Best AllChinaBuy";
export const heroTitle2 = "Spreadsheet Directory 2026";
export const heroSubtitle = "Discover thousands of curated finds, trusted links, shopping guides, and buying resources — all in one place. The ultimate AllChinaBuy spreadsheet directory for shoes, clothing, bags, and accessories.";
export const ctaSheet = "allchinabuy sheet";
export const ctaBuy = "buy it now";

export const aboutLabel = "WHY USE ALLCHINABUY SHEET";
export const aboutText = "The AllChinaBuy Spreadsheet is a carefully curated shopping directory that transforms how you discover products, compare prices, and find trusted sources. Whether you are hunting for sneakers, hoodies, bags, or accessories, our allchinabuy sheet resources simplify every step of your shopping journey. Built by a community of experienced shoppers, each entry in the allchinabuy spreadsheet is verified for quality and updated daily to ensure you always access the freshest finds and most reliable links available anywhere online.";

export const comparisonData = [
  { feature: "Product Organization", ours: true, manual: false },
  { feature: "Price Comparison", ours: true, manual: false },
  { feature: "Trusted Sources", ours: true, manual: "Limited" },
  { feature: "Buying Guides", ours: true, manual: "No" },
  { feature: "Daily Updates", ours: true, manual: "No" },
  { feature: "Community Verified", ours: true, manual: "No" },
  { feature: "Free Access", ours: true, manual: true },
];

export const trustBadges = [
  "Updated Daily",
  "Free Access",
  "Beginner Friendly",
  "Community Recommended",
  "Buying Guides Included",
];

export const trendingTitle = "Trending Finds";
export const trendingSubtitle = "Updated daily from community picks";

export const faqs = [
  {
    q: "What is the AllChinaBuy Spreadsheet?",
    a: "The AllChinaBuy Spreadsheet is a curated shopping directory that helps users discover products, compare prices, and find trusted sources faster. It organizes thousands of product links across categories like shoes, clothing, bags, and accessories — all in one easy-to-navigate spreadsheet format.",
  },
  {
    q: "How do I use the AllChinaBuy Spreadsheet?",
    a: "Simply browse the categories or use the dropdown menu to navigate to your desired product type. Each link leads directly to the product listing on our main website, where you can explore detailed information, compare options, and start shopping immediately.",
  },
  {
    q: "Is the AllChinaBuy Spreadsheet free?",
    a: "Yes, the AllChinaBuy Spreadsheet is completely free to access. There are no hidden fees, subscriptions, or payments required. We believe in making quality shopping resources accessible to everyone.",
  },
  {
    q: "How often is the spreadsheet updated?",
    a: "Our allchinabuy spreadsheet is updated daily with new product finds, price changes, and fresh links. The community actively contributes new discoveries, and our team verifies each entry to maintain quality and accuracy.",
  },
  {
    q: "Is AllChinaBuy safe to use?",
    a: "We provide informational resources and curated links to help you make informed shopping decisions. We always recommend verifying product information, shipping methods, and seller details before making any purchase.",
  },
  {
    q: "What categories are available in the spreadsheet?",
    a: "The allchinabuy spreadsheet covers 14 major categories including Shoes, Hoodies & Sweaters, T-Shirts, Jackets, Pants & Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes, and Other Stuff.",
  },
];

export const safetyTitle = "Safety Notice";
export const safetyText = "Always verify product information, shipping methods, and seller details before making purchases. This website provides informational resources only. We do not sell products directly — we connect you to trusted sources through our curated allchinabuy spreadsheet directory.";

export const finalCTATitle = "Start Exploring The Best AllChinaBuy Spreadsheet Today";
export const finalCTASubtitle = "Thousands of curated finds, updated daily, completely free. Your next great discovery is just one click away.";

export const comparisonTitle = "Why Our Spreadsheet?";
export const comparisonSubtitle = "See how the AllChinaBuy Spreadsheet compares to manual searching";